import { Route, AppId, createPageRoute } from '@lumapps/router';

export const siteGroupsRoute: Route = createPageRoute({
    slug: 'site/groups',
    appId: AppId.backOffice,
});
